
import ProjectFactory from "@/web3/projectFactory";
import { defineComponent } from "vue";
export default defineComponent({
  data: function () {
    return {
      contractAddress: "",
    };
  },
  methods: {
    async setup() {
        try {
          let contract = await ProjectFactory.createContract();
          this.contractAddress = contract.options.address;
        } catch (e) {
          console.log(e);
        }
    },
  },
});
